<tr *ngIf="!desktop">
    <th colspan="2" class="pt-9">
        <div class="text-left pl-3 flex items-center space-x-3">
            <span class="p-input-icon-left" *ngIf="showApplyButton">
                <p-button title="Apply" (click)="apply()" styleClass="top-[8px] h-[38px] px-4" label="Apply">
                </p-button>
            </span>
            <i title="Show More Filters" *ngIf="showMoreFiltersButton" (click)="showAdvancedFilters()"
                class="cursor-pointer show-more-filters mt-3" [ngClass]="{
                    'text-gray-600 hover:text-gray-800': !showMoreFilters,
                    'text-red-600 hover:text-red-800': showMoreFilters
                }">
            </i>
            <i title="Clear filters" [hidden]="!showClearButton" (click)="clearFilters()"
                class="cursor-pointer pi pi-times mt-4 mr-3" [ngClass]="{
                    'text-gray-600 hover:text-gray-800': true
                }" style="margin-right: 15px;">
            </i>
        </div>
    </th>
</tr>

<tr class="noborder-th">
    <th [attr.colspan]="colspan()" class="pt-6 pb-1" pSortableColumnDisabled>
        <ng-content *ngIf="desktop || (!desktop && showMoreFilters)"></ng-content>
    </th>
    <th *ngIf="desktop" width="5%" class="text-center pt-9">
        <div class="flex items-center space-x-3">
            <span class="p-input-icon-left" *ngIf="showApplyButton">
                <p-button title="Apply" (click)="apply()" styleClass="top-[8px] h-[38px] px-4" label="Apply">
                </p-button>
            </span>
            <i title="Show More Filters" (click)="showAdvancedFilters()" class="cursor-pointer show-more-filters mt-3"
                [ngClass]="{
                    'text-gray-600 hover:text-gray-800': !showMoreFilters,
                    'text-red-600 hover:text-red-800': showMoreFilters,
                    'invisible': !showMoreFiltersButton
                }">
            </i>
            <i title="Clear filters" (click)="clearFilters()" class="cursor-pointer pi pi-times mt-4 mr-3" [ngClass]="{
                    'text-gray-600 hover:text-gray-800': true,
                    'invisible': !showClearButton
                }" style="margin-right: 15px;">
            </i>
        </div>
    </th>
</tr>